<template>
   <Teleport :to="'body'">
      <NxtSideModal
         v-if="shown"
         :title="$t('settings')"
         :width="'92.3rem'"
         @on-close="$emit('close')"
      >
         <div class="settings">
            <SettingsMenu
               :tabs="tabs"
               :selectedTab="selectedTab"
               @on-tab-change="(tab) => (selectedTab = tab.key)"
            />

            <div class="settings__main">
               <h2 v-if="selectedTab">{{ $t(`general_tab.${selectedTab}`) }}</h2>
               <GeneralSettings v-if="selectedTab === 'general'" />
            </div>
         </div>
      </NxtSideModal>
   </Teleport>
</template>

<script>
import GeneralSettings from '@/core/components/GeneralSettings.vue';
import SettingsMenu from '@/core/components/SettingsMenu.vue';
import { NxtSideModal } from '@nxtpeople/nxt-styles';

export default {
   components: {
      SettingsMenu,
      GeneralSettings,
      NxtSideModal,
   },

   emits: ['close'],

   props: {
      shown: { type: Boolean, default: false },
   },

   data() {
      return {
         showSettingsPanel: false,
         selectedTab: null,
         tabs: [
            {
               key: 'general',
               children: [],
            },
         ],
      };
   },

   mounted() {
      this.selectedTab = this.tabs[0]['key'];
   },
};
</script>

<style lang="scss" scoped>
.settings {
   display: flex;
   width: 100%;
   height: 100%;
   gap: 3.6923076923rem;
   &__main {
      width: 100%;
      position: relative;
      h2 {
         margin: unset;
         margin-top: 0.6153846154rem;
         margin-bottom: 1.8461538462rem;
      }
   }
}
</style>
